import { Suspense } from 'react';
import { AggregationWidget } from './aggregation-widget';
import { CampaignsWidget } from './campaigns-widget';
import { CountryWidget } from './country-widget';
import { DauWidget } from './dau-widget';
import { EventWidget } from './event-widget';
import { ReferrerWidget } from './referrer-widget';
import { RetentionWidget } from './retention-widget';
import { Widget } from './widget';
import type {
  AggregationWidgetProps,
  EventWidgetProps,
  WidgetProps,
} from './types';

// FUNNEL is intentionally not handled here — it depends on admin-only
// services and stays in the admin app, which wraps this component and
// dispatches FUNNEL itself.
export const WidgetWrapper = (
  props: WidgetProps | EventWidgetProps | AggregationWidgetProps,
) => {
  const { type } = props;

  if (type) {
    return (
      <Suspense fallback={<Widget hideMenu loading />}>
        {(() => {
          switch (type) {
            case 'AGGREGATION_BY_PROPERTY':
              return (
                <AggregationWidget {...(props as AggregationWidgetProps)} />
              );
            case 'COUNTRY':
              return <CountryWidget {...(props as WidgetProps)} />;
            case 'CAMPAIGNS':
              return <CampaignsWidget {...(props as WidgetProps)} />;
            case 'DAU':
              return <DauWidget {...(props as WidgetProps)} />;
            case 'EVENT':
              return <EventWidget {...(props as EventWidgetProps)} />;
            case 'REFERRER':
              return <ReferrerWidget {...(props as WidgetProps)} />;
            case 'RETENTION':
              return <RetentionWidget {...(props as WidgetProps)} />;
            default:
              return null;
          }
        })()}
      </Suspense>
    );
  } else {
    console.error('Invalid widget type');
    return null;
  }
};
